import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { usePageTitle } from './hooks/usePageTitle';
import HomePage from './components/HomePage';
import PlanSelectionPage from './components/PlanSelectionPage';
import Header from './components/Header';
import Footer from './components/Footer';
import SubscriptionProcessingPage from './components/SubscriptionProcessingPage';
import { LanguageProvider } from './components/LanguageContext';
import './App.css';

function App() {
  // Set default title for the app
  usePageTitle('IZYPOS Onboarding');

  return (
    <LanguageProvider>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/choose-your-plan" element={<PlanSelectionPage />} />
          <Route path="/processing-subscription" element={<SubscriptionProcessingPage />} />
        </Routes>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App; 